exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.test1[data-v-1fe48fde]{\n  z-index: 100;\n  color:aqua;\n  font-size: 30;\n}\n", ""]);

// exports
